import { render, staticRenderFns } from "./SetMetadata.vue?vue&type=template&id=00e05b77&"
import script from "./SetMetadata.vue?vue&type=script&lang=ts&"
export * from "./SetMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./SetMetadata.vue?vue&type=style&index=0&id=00e05b77&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports